/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React from "react";
import { useState, useEffect } from "react";
import * as API from "../../../api/emr";

const GeneralInformation = ({ row }) => {
    const [duration, setDuration] = useState("Year Month Day");

    const calculateBmi = (height, weight) => {
        let height_in_m = height / 100;
        if (height_in_m > 0 && weight > 0) {
            let bmi = weight / (height_in_m * height_in_m);
            return bmi.toFixed(2);
        } else {
            return;
        }
    };

    const [generalInformation, setGeneralInformation] = useState({
        patientName: `${row?.firstName} ${row?.lastName}`,
        age: "",
        height: row?.height || "",
        weight: row?.weight || "",
        bmi: (row?.height && row?.weight) ? calculateBmi(row?.height, row?.weight) : "",
        bp: row?.bp || "",
        gender: row?.gender === "Male" ? "M" : "F",
        pulse: row?.pulse || "",
        temperature: row?.temperature || "",
    });

    const getGeneralInfo = async () => {
        console.log(row, "----------------row")
        let resp = await API.generalInformation({ patientId: row?._id });
        if (resp.data && resp.data.status === "Success") {
            setGeneralInformation({
                patientName: resp.data.data.name,
                age: resp.data.data.age,
                height: resp.data.data.height,
                weight: resp.data.data.weight,
                bmi: resp.data.data.bmi,
                bp: resp.data.data.bp,
                gender: resp.data.data.gender,
                pulse: resp.data.data.pulse,
                temperature: resp.data.data.temprature,
            });
            if (resp.data.data.diabitic === "yes") {
                let strDuration = "";

                if (
                    resp.data.data.diabtiesDuration?.years === 0 &&
                    resp.data.data.diabtiesDuration?.months === 0 &&
                    resp.data.data.diabtiesDuration?.days === 0
                ) {
                    strDuration = "";
                }
                if (resp.data.data?.diabtiesDuration?.years > 0) {
                    strDuration = resp.data.data.diabtiesDuration?.years + " years ";
                }
                if (resp.data.data.diabtiesDuration?.months > 0) {
                    strDuration += resp.data.data.diabtiesDuration?.months + " months ";
                }
                if (resp.data.data.diabtiesDuration?.days > 0) {
                    strDuration += resp.data.data.diabtiesDuration?.days + " days ";
                }
                setDuration(strDuration);
            }
        }
    };

    useEffect(() => {
        getGeneralInfo();
    }, [row]);
    return (
        <div className="general-information">
            <div className="card_header">
                <div className="card_header_inner">
                    <ul className="patient_details">
                        <li style={{ minWidth: "140px" }}>
                            <a className="user-info-img">
                                {/* <span><img src={GeneralUsrImg} alt="" /> </span> */}
                                {generalInformation.patientName}
                            </a>
                        </li>
                        <span className="flex" style={{ lineHeight: "20px" }}>
                            <li>
                                <a>
                                    <span>Age: </span> {generalInformation.age} Y /{" "}
                                    {generalInformation.gender === "Male" ? " M" : " F"}
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>Height{generalInformation.height > 0 ? ":" : ""} </span>{" "}
                                    {generalInformation.height > 0
                                        ? generalInformation.height
                                        : ""}{" "}
                                    {generalInformation.height > 0 ? "CM" : ""}
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>Weight{generalInformation.weight > 0 ? ":" : ""} </span>{" "}
                                    {generalInformation.weight > 0
                                        ? generalInformation.weight
                                        : ""}{" "}
                                    {generalInformation.weight > 0 ? "KG" : ""}
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>BMI{generalInformation.bmi > 0 ? ":" : ""} </span>{" "}
                                    {generalInformation.bmi > 0 ? generalInformation.bmi : ""}
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>BP{generalInformation.bp !== "/" ? ":" : ""} </span>{" "}
                                    {generalInformation.bp !== "/" ? generalInformation.bp : ""}{" "}
                                    {generalInformation.bp !== "/" ? " mmHg" : ""}
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>Pulse{generalInformation.pulse > 0 ? ":" : ""} </span>{" "}
                                    {generalInformation.pulse > 0 ? generalInformation.pulse : ""}{" "}
                                    {generalInformation.pulse > 0 ? "/min" : ""}
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>
                                        Temperature{generalInformation.temperature > 0 ? ":" : ""}{" "}
                                    </span>{" "}
                                    {generalInformation.temperature > 0
                                        ? generalInformation.temperature
                                        : ""}{" "}
                                    {generalInformation.temperature > 0 ? "F" : ""}{" "}
                                </a>
                            </li>
                            <li>
                                <a>
                                    <span>Diabetes Duration: </span> {duration}{" "}
                                </a>
                            </li>
                        </span>
                    </ul>
                    {/* <div className="patient_history_btn">
                        <NavLink to={`/history/${row?.patientId}`} className="btn btn-fill btn-secondary pull-right">All Visit</NavLink>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default GeneralInformation;
